/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const LicenceManagement = lazyLoad(
  () => import('./index'),
  module => {
    return module.LicenceManagement;
  },
);
